export const API_URI = process.env.REACT_APP_BACKEND_URL_ROOT;

export interface IUserBackend {
  email: string;
  is_premium: false;
  profile: IProfileBackend;
  username: string;
  image: string;
  last_login: string;
  is_first_login: boolean;
}

export interface IUser {
  email: string;
  isPremium: false;
  username: string;
  company: string;
  firstName: string;
  image: string | null;
  lastName: string;
  lastLogin: string;
  isFirstLogin: boolean;
}

export interface IProfile {
  company: string;
  firstName: string;
  image: string | null;
  lastName: string;
}

export interface IProfileBackend {
  company: string;
  first_name: string;
  image: string | null;
  last_name: string;
}
export const createUser = (
  user: IUserBackend,
  profile: IProfileBackend
): IUser => {
  let img: string | null = null;
  if (
    API_URI &&
    process.env.NODE_ENV === "development" &&
    profile.image !== null
  )
    img = API_URI + profile.image;
  else {
    if (profile.image !== null) {
      img = profile.image;
    }
  }
  return Object.freeze({
    username: user.username,
    isPremium: user.is_premium,
    email: user.email,
    image: img,
    company: profile.company,
    firstName: profile.first_name,
    lastLogin: user.last_login,
    lastName: profile.last_name,
    isFirstLogin: user.is_first_login,
  });
};

export const createProfile = (profile: IProfileBackend): IProfile => {
  let img: string | null = null;
  if (
    API_URI &&
    process.env.NODE_ENV === "development" &&
    profile.image !== null
  )
    img = API_URI + profile.image;
  else {
    if (profile.image !== null) {
      img = profile.image;
    }
  }

  return Object.freeze({
    image: img,
    company: profile.company,
    firstName: profile.first_name,
    lastName: profile.last_name,
  });
};
